import React, { useState, useCallback, useMemo, useEffect } from "react";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import * as Yup from "yup";
import { useFormik } from "formik";
import Flatpickr from "react-flatpickr";
import { getId, getRole } from "../../utils/helpers/custom";
import { ResponseStatusEnum } from "../../utils/helpers/enums";
import TableContainer from "../../components/common/tableContainer";
import Loader from "../../components/common/loader";
import { InputPlaceHolder, RequiredField, SelectPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import NoResultsMessage from "../../components/noResultMessage";
import DeleteModal from "../../components/common/deleteModal";
import {
  addDailyUpdateApi,
  deleteDailyUpdateApi,
  editDailyUpdateApi,
  listOFDailyUpdateApi,
} from "../../api/dailyUpdateApi";
import { checkStatusCodeSuccess, CommonLabel, dateFormat, errorHandler, HandleResponse, Roles, SerialNoCol } from "../../utils/helpers/common";
import { SupportLabel } from "../../common/constant/Support";
import { Link } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseInput from "../../components/BaseComponents/BaseInput";
import BaseModal from "../../components/BaseComponents/BaseModal";

const DailyUpdate = () => {
  const id = getId();
  const role = getRole();

  const [todo, setTodo] = useState(null);
  const [modalTodo, setModalTodo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listOfDailyUpdateData, setListOfDailyUpdateData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editDailyUpdateCellData, setEditDailyUpdateCellData] = useState();
  const [modalLoader, setModalLoader] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);

  const fetchData = () => {
    setTableLoader(true);
    listOFDailyUpdateApi({})
      .then((response) => {
        const reversedData = response?.data?.data;
        setListOfDailyUpdateData(reversedData);
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setTableLoader(false);
      });
  }
  useEffect(() => {
    fetchData();
  }, []);

  //Add Daily Update
  const addDailyUpdate = () => {
    newAddDailyUpdate.resetForm();
    setEditDailyUpdateCellData("");
    setModalTodo("");
    setModalTodo(!modalTodo);

    setModalTodo([]);
    toggle();
    setIsEdit(false);
  };

  const editDailyUpdateHandle = (data) => {
    newAddDailyUpdate.resetForm();
    setEditDailyUpdateCellData(data);

    setModalTodo("");
    setIsEdit(true);
    setModalTodo(!modalTodo);
    setModalTodo([]);
    setTodo([]);
    toggle();
  };

  const toggle = useCallback(() => {
    newAddDailyUpdate.resetForm();
    if (modalTodo) {
      setModalTodo(false);
      newAddDailyUpdate.resetForm();

      setModalTodo(null);
    } else {
      newAddDailyUpdate.resetForm();
      setModalTodo(true);
    }
  }, [modalTodo]);

  //meomo
  const QueryColumnsAdmin = useMemo(() => [
    SerialNoCol(),
    {
      Header: SupportLabel.Title,
      accessor: "title",
      filterable: false,
    },
    {
      Header: SupportLabel.Description,
      accessor: "description",
      filterable: false,
    },
    {
      Header: SupportLabel.StartDate,
      accessor: "startDate",
      Cell: (cell) => {
        const date = cell?.row?.original?.startDate;
        return (
          <div>
              {dateFormat(date) !== CommonLabel.InvalidDate ? dateFormat(date) : HandleResponse.NoData}
          </div>
        )
      }
    },
    {
      Header: SupportLabel.EndDate,
      accessor: "endDate",
      Cell: (cell) => {
        const date = cell?.row?.original?.endDate;
        return (
          <div>
              {dateFormat(date) !== CommonLabel.InvalidDate ? dateFormat(date) : "---"}
          </div>
        )
      }
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div className="hstack gap-2">
            <Link
              className="btn btn-sm btn-soft-info edit-list"
              onClick={() => editDailyUpdateHandle(cellProps?.row?.original)}
            >
              <i className="ri-pencil-fill align-bottom" />
            </Link>
            <Link className="btn btn-sm btn-soft-danger remove-list">
              <i
                className="ri-delete-bin-5-fill align-bottom"
                onClick={() => dailyUpdateDelete(cellProps?.row?.original?.id)}
              />
            </Link>
          </div>
        );
      },
    },
  ]);

  //Daily Update Data
  const columns = useMemo(() => [
    SerialNoCol(),
    {
      Header: SupportLabel.Title,
      accessor: "title",
      filterable: false,
    },
    {
      Header: SupportLabel.Description,
      accessor: "description",
      filterable: false,
    },
    {
      Header: SupportLabel.StartDate,
      accessor: "startDate",
      Cell: (cell) => {
        const date = cell?.row?.original?.startDate;
        return (
          <div>
              {dateFormat(date) !== CommonLabel.InvalidDate ? dateFormat(date) : HandleResponse.NoData}
          </div>
        )
      }
    },
    {
      Header: SupportLabel.EndDate,
      accessor: "endDate",
      Cell: (cell) => {
        const date = cell?.row?.original?.endDate;
        return (
          <div>
              {dateFormat(date) !== CommonLabel.InvalidDate ? dateFormat(date) : HandleResponse.NoData}
          </div>
        )
      }
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div>
            <div className="hstack gap-2">
              <Link
                id={`edit-${cellProps?.row?.original?.id}`}
                className="btn btn-sm btn-soft-info edit-list"
                onClick={() => editDailyUpdateHandle(cellProps?.row?.original)}
              >
                <i className="ri-pencil-fill align-bottom" />
              </Link>
              <ReactTooltip
                place="bottom"
                variant="info"
                content={CommonLabel.Update}
                anchorId={`edit-${cellProps?.row?.original?.id}`}
              />
              <Link className="btn btn-sm btn-soft-danger remove-list">
                <i
                  id={`delete-${cellProps?.row?.original?.id}`}
                  className="ri-delete-bin-5-fill align-bottom"
                  onClick={() => dailyUpdateDelete(cellProps?.row?.original?.id)}
                />
              </Link>
              <ReactTooltip
                place="bottom"
                variant="error"
                content={CommonLabel.Delete}
                anchorId={`delete-${cellProps?.row?.original?.id}`}
              />
            </div>
          </div>
        );
      },
    },
  ]);

  const newAddDailyUpdate = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: editDailyUpdateCellData?.title || "",
      description: editDailyUpdateCellData?.description || "",
      startDate: editDailyUpdateCellData?.startDate || "",
      endDate: editDailyUpdateCellData?.endDate || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required(validationMessages.required(SupportLabel.Title)),
      description: Yup.string().required(validationMessages.required(SupportLabel.Description)),
      startDate: Yup.date().required(validationMessages.required(SupportLabel.StartDate)),
      endDate: Yup.date().required(validationMessages.required(SupportLabel.EndDate)),
    }),
    onSubmit: (values) => {
      setModalLoader(true);
      if (isEdit) {
        editDailyUpdateApi(editDailyUpdateCellData?.id, { ...values })
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              newAddDailyUpdate.resetForm();
              toast.success(response?.data?.message);
              setModalTodo(false);
              fetchData();
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((err) => {
            return err;
          })
          .finally(() => {
            setModalLoader(false);
          });
      } else {
        addDailyUpdateApi({ userId: id, ...values })
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              toast.success(response?.data?.message);
              fetchData();
              setModalTodo(false);
              newAddDailyUpdate.resetForm();
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((err) => {
            return err;
          })
          .finally(() => {
            setModalLoader(false);
          });
      }
    },
  });
 
  // Delete To do
  const [deleteid, setdeleteid] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const dailyUpdateDelete = (id) => {
    setdeleteid(id);
    setTodo(todo);
    setDeleteModal(true);
  };

  const handleDeleteTodo = () => {
    setModalLoader(true);
    deleteDailyUpdateApi(deleteid).then((resp) => {
      if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
        fetchData();
        setDeleteModal(false);
        toast.success(resp?.data?.message);
      } else {
        toast.error(resp?.data?.message);
      }
    }).catch((err) => {
      errorHandler(err);
    })
    .finally(() => {
      setModalLoader(false);
    });
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
        loader={modalLoader}
      />
      <div className="page-content">
        {loading === false ? (
          <Container fluid>
            <BreadCrumb title={SupportLabel.DailyUpdate} pageTitle="HRMS" />
            <Row className="mb-2">
              <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                <h5 className="fw-semibold mt-2">{SupportLabel.DailyUpdate}</h5>
              </div>

              {role === Roles.HR || role === Roles.Admin ? (
                <div className="col-auto order-2 order-sm-3 ms-auto">
                  <div className="hstack gap-2">
                    <BaseButton
                      color="primary"
                      type="button"
                      onClick={() => addDailyUpdate()}
                    >
                      <i className="ri-add-line align-bottom"></i>
                      {SupportLabel.AddDailyUpdate}
                    </BaseButton>
                  </div>
                </div>
              ) : null}
            </Row>

            {role === Roles.HR ? (
              <>
                <Card>
                  <CardBody>
                    {(listOfDailyUpdateData?.length || tableLoader) ? (
                      <TableContainer
                        columns={columns}
                        data={listOfDailyUpdateData}
                        isAddUserList={false}
                        isGlobalFilter={true}
                        customPageSize={5}
                        tableLoader={tableLoader}
                        divClass="table-responsive table-card mb-1"
                        tableClass="align-middle table-wrap"
                        theadClass="table-light text-muted"
                      />
                    ) : (
                      <NoResultsMessage />
                    )}
                  </CardBody>
                </Card>
              </>
            ) : role === Roles.Admin ? (
              <Card>
                <CardBody>
                  <TableContainer
                    columns={QueryColumnsAdmin}
                    data={listOfDailyUpdateData}
                    isAddUserList={false}
                    customPageSize={5}
                    tableLoader={tableLoader}
                    divClass="table-responsive table-card mb-1 "
                    tableClass="align-middle table-wrap "
                    theadClass="table-light text-muted"
                  />
                </CardBody>
              </Card>
            ) : null}
          </Container>
        ) : (
          <Loader />
        )}
      </div>

      <BaseModal
        open={modalTodo}
        onClose={() => setModalTodo(false)}
        toggle={toggle}
        className="zoomIn"
        title={isEdit ? SupportLabel.EditDailyUpdate : SupportLabel.AddDailyUpdate}
        bodyClassName="p-4"
        submit={newAddDailyUpdate.handleSubmit}
        submitLabel={isEdit ? CommonLabel.Update : CommonLabel.Add}
        submitLabelColor="primary"
        closeLabel={CommonLabel.Close}
        loader={modalLoader}
        closeLabelColor="ghost-success"
      >
        <Form
          id="creattask-form"
          onSubmit={(e) => {
            e.preventDefault();
            newAddDailyUpdate.handleSubmit();
            return false;
          }}
        >
          <Row className="mb-3">
            <Col lg={12}>
              <div className="mb-3">
                <BaseInput
                  type="text"
                  name="title"
                  placeholder={InputPlaceHolder(SupportLabel.Issue)}
                  label={SupportLabel.Title}
                  onChange={newAddDailyUpdate.handleChange}
                  handleBlur={newAddDailyUpdate.handleBlur}
                  value={newAddDailyUpdate.values.title}
                  touched={newAddDailyUpdate.touched.title}
                  error={newAddDailyUpdate.errors.title}
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <BaseInput
                  type="textarea"
                  name="description"
                  placeholder={InputPlaceHolder(SupportLabel.Description)}
                  label={SupportLabel.Description}
                  onChange={newAddDailyUpdate.handleChange}
                  handleBlur={newAddDailyUpdate.handleBlur}
                  value={newAddDailyUpdate.values.description}
                  touched={newAddDailyUpdate.touched.description}
                  error={newAddDailyUpdate.errors.description}
                  rows={4}
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="startDateInput" className="form-label required">
                  {SupportLabel.StartDate}:
                </Label>
                <Flatpickr
                  className={`form-control ${
                    newAddDailyUpdate.errors.startDate && "is-invalid"
                  }`}
                  id="startDateInput"
                  placeholder={SelectPlaceHolder(SupportLabel.StartDate)}
                  name="startDate"
                  onBlur={newAddDailyUpdate.handleBlur}
                  value={newAddDailyUpdate.values.startDate || ""}
                  options={{
                    altInput: true,
                    altFormat: "F j, Y",
                    dateFormat: "Y-m-d",
                    onChange: function (selectedDates, dateStr) {
                      newAddDailyUpdate.setFieldValue("startDate", dateStr);
                      const maxEndDate = new Date(selectedDates[0]);
                      maxEndDate.setDate(maxEndDate.getDate() + 7);
                      document
                        .getElementById("endDateInput")
                        ._flatpickr.set("maxDate", maxEndDate);
                    },
                  }}
                />
                {newAddDailyUpdate.touched.startDate &&
                  newAddDailyUpdate.errors.startDate && (
                    <FormFeedback type="invalid">
                      {newAddDailyUpdate.errors.startDate}
                    </FormFeedback>
                  )}
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="endDateInput" className="form-label required">
                  {SupportLabel.EndDate}:
                </Label>
                <Flatpickr
                  className={`form-control ${
                    newAddDailyUpdate.errors.endDate && "is-invalid"
                  }`}
                  id="endDateInput"
                  placeholder={SelectPlaceHolder(SupportLabel.EndDate)}
                  name="endDate"
                  onBlur={newAddDailyUpdate.handleBlur}
                  value={newAddDailyUpdate.values.endDate || ""}
                  onChange={(selectedDates, dateStr) => {
                    newAddDailyUpdate.setFieldValue("endDate", dateStr);
                    const minStartDate = new Date(selectedDates[0]);
                    minStartDate.setDate(minStartDate.getDate() - 7);
                    document
                      .getElementById("startDateInput")
                      ._flatpickr.set("minDate", minStartDate);
                  }}
                  options={{
                    altInput: true,
                    altFormat: "F j, Y",
                    dateFormat: "Y-m-d",
                  }}
                />
                {newAddDailyUpdate.touched.endDate &&
                  newAddDailyUpdate.errors.endDate && (
                    <FormFeedback type="invalid">
                      {newAddDailyUpdate.errors.endDate}
                    </FormFeedback>
                  )}
              </div>
            </Col>
          </Row>
        </Form>
      </BaseModal>
    </React.Fragment>
  );
};

export default DailyUpdate;
